module.exports = __webpack_public_path__ + "static/media/pizzaHut.396af7c5.webp";